const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId: state => state.user.userId,
  userInfo: state => state.user.userInfo,
  isSuperAdmin: state => state.user.userInfo.RoleId === 0,
};
export default getters
